import { render, staticRenderFns } from "./BlackListGeneralsFilter.vue?vue&type=template&id=70b30346&"
import script from "./BlackListGeneralsFilter.vue?vue&type=script&lang=ts&"
export * from "./BlackListGeneralsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports